'use client';

import {
  ChangeEvent,
  CSSProperties,
  InputHTMLAttributes,
  // useState,
} from 'react';
import styles from './Switch.module.css';

export const Switch = (
  props: InputHTMLAttributes<HTMLInputElement> & {
    accentColor?: CSSProperties['color'];
  },
) => {
  // const [checked, setChecked] = useState<boolean>(props.checked as boolean);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    // setChecked(e.target.checked);
    if (props.onChange) props.onChange(e);
  };

  return (
    <label
      className={[
        styles.root,
        props.className,
        props.checked && styles.active,
        props.disabled && styles.disabled,
      ]
        .filter(Boolean)
        .join(' ')}
      style={
        props.accentColor
          ? ({ '--switch-accent': props.accentColor } as CSSProperties)
          : undefined
      }
    >
      <input
        {...props}
        className={`switch-checkbox`}
        type="checkbox"
        checked={props.checked}
        onChange={handleChange}
      />
      <span
        className={['switch-slider', props.checked && styles.active]
          .filter(Boolean)
          .join(' ')}
      ></span>
    </label>
  );
};
